import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
  signOut as firebaseSignOut,
  createUserWithEmailAndPassword as firebaseCreateUserWithEmailAndPassword,
  onAuthStateChanged as firebaseOnAuthStateChanged,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseClientEnabled = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId
);

const disabledAuth = {
  currentUser: null,
  onAuthStateChanged(callback) {
    const timer = setTimeout(() => callback(null), 0);
    return () => clearTimeout(timer);
  },
};

let app = null;
let auth = disabledAuth;
let db = null;
let analytics = null;

if (firebaseClientEnabled) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  if (typeof window !== "undefined" && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
  }
} else {
  console.info("Firebase client auth inactive for frozen Saveback runtime");
}

function inactiveAuthError() {
  return new Error("firebase_client_auth_inactive_for_frozen_saveback_runtime");
}

const signInWithEmailAndPassword = (...args) => {
  if (!firebaseClientEnabled) return Promise.reject(inactiveAuthError());
  return firebaseSignInWithEmailAndPassword(...args);
};

const signOut = (...args) => {
  if (!firebaseClientEnabled) return Promise.resolve();
  return firebaseSignOut(...args);
};

const createUserWithEmailAndPassword = (...args) => {
  if (!firebaseClientEnabled) return Promise.reject(inactiveAuthError());
  return firebaseCreateUserWithEmailAndPassword(...args);
};

const onAuthStateChanged = (...args) => {
  if (!firebaseClientEnabled) return disabledAuth.onAuthStateChanged(args[1] || (() => {}));
  return firebaseOnAuthStateChanged(...args);
};

export {
  app,
  auth,
  db,
  analytics,
  firebaseClientEnabled,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  onAuthStateChanged
};
